import dayjs from 'dayjs';
export const unitFormat = val => {
  const v = Number(val);
  if (v === 1) {
    return '元/小时';
  } else if (v === 2) {
    return '元/天';
  } else if (v === 3) {
    return '元/次';
  } else if (v === 4) {
    return '元/月';
  }
};

export const dateFormat = val => {
  return val ? dayjs(val).format('YY-MM-DD') : '';
};
export const hidePhone = val => {
  return val ? val.slice(0, 3) + '****' + val.slice(7, 11) : '';
};
export const dateTimeFormat = val => {
  return val ? dayjs(val).format('MM-DD HH:mm') : '';
};
export const dateFilter = val => {
  const currentDate = dayjs(new Date());
  const diff = currentDate.diff(dayjs(val), 'm');
  if (diff < 1) {
    return '刚刚';
  } else if (diff >= 1 && diff < 60) {
    return `${diff}分钟前`;
  } else if (diff >= 60 && diff < 1 * 60 * 24) {
    const min = Math.round(diff / 60);
    return `${min}小时前`;
  } else if (diff >= 1 * 60 * 24 && diff < 7 * 60 * 24) {
    const day = Math.round(diff / 2400);
    return `${day}天前`;
  } else if (diff >= 7 * 60 * 24) {
    return dayjs(val).format('M月D号');
  }
};
export const timeFilter = val => {
  return val ? dayjs(val).format('HH:mm') : '';
};

export default {
  unitFormat,
  dateFormat,
  hidePhone,
  dateFilter,
  timeFilter,
  dateTimeFormat,
};
